export default __webpack_public_path__ + "static/thumb-trackers-e57809cd4b4dcb9bc435ea36be14b4a6.png";